import { Component, Input, OnInit } from '@angular/core';
import { ContactInfo } from 'src/app/store/application';
import { isMobile } from 'src/assets/isMobileChecker';

@Component({
  selector: 'app-submission-complete',
  templateUrl: './submission-complete.component.html',
  styleUrls: ['./submission-complete.component.scss']
})
export class SubmissionCompleteComponent implements OnInit {

  @Input() contactInfo: ContactInfo;

  isMobile = isMobile;
  shouldExpandDropdown = false;

  constructor() { }

  ngOnInit(): void {
    sessionStorage.clear();
  }

  setExpandCollapseIcon() {
    this.shouldExpandDropdown = !this.shouldExpandDropdown;
  }

  getExpandCollapseIcon(): string {
    if (this.shouldExpandDropdown) {
      return '<i class="fas fa-minus"></i>';
    } else {
      return '<i class="fas fa-plus"></i>';
    }
  }

  openWebTab(webpage: string) {
    window.open(webpage, '_blank')
  }

}
